import React, { useEffect, useState } from "react";
import useThemeColors from "../../vehicle/ThemeColors";
import { GARAGE_TOKEN, WORKSHOP_ID } from "../../../constants";
import axios from "axios";
import ReactModal from "react-modal";
import { capitalizeFirstLetter } from "../../../components/reusableComponent/CapitalLetter";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../../components/reusableComponent/DateFormat";

const ServiceRequest = () => {
  const [bookingRequestData, setBookingRequestData] = useState([]);
  const [isServiceRequestModalOpen, setIsServiceRequestModalOpen] =
    useState(false);
  const [cancelServiceRequestedId, setCancelServiceRequestedId] = useState("");
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [isServiceConfirmModalOpen, setIsServiceConfirmModalOpen] =
    useState(false);
  const [getCompleteRowDetails, setGetCompleteRowDetails] = useState<any>({});
  const [openDetailsPage, setOpenDetailsPage] = useState(false);

  const getWorkshopId = localStorage.getItem(WORKSHOP_ID);
  const navigate = useNavigate();

  const fetchingTenant = window.location.hostname.split(".")[0];
  const apiPort = process.env.REACT_APP_API_PROTOCOL;
  const token = localStorage.getItem(GARAGE_TOKEN);

  const fetchServiceRequestAPI = async () => {
    try {
      const response = await axios.get(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/workshop-booking-requests/?workshop_id=${getWorkshopId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setBookingRequestData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  useEffect(() => {
    fetchServiceRequestAPI();
  }, []);

  const header = [
    { label: "Request Id", key: "id" },
    { label: "Service Name", key: "service_name" },
    { label: "Sub Service", key: "sub_service" },
    { label: "Service Date", key: "service_date" },
    { label: "Vehicle Number", key: "vehicle_number" },
    { label: "Status", key: "status" },
    { label: "Action", key: "action" },
  ];

  const closeModal = () => {
    setIsServiceRequestModalOpen(false);
    setOpenCancelModal(false);
    setIsServiceConfirmModalOpen(false);
  };

  const { selectedColor } = useThemeColors();

  const customModalStyles1: ReactModal.Styles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-40%, -50%)",
      width: "30%",
      border: "none",
      boxShadow: `${selectedColor}80 1px 1px 10px 1px`,
      borderRadius: "40px",
      padding: "5px",
    },
  };

  const cancelServiceHandler = (id) => {
    setCancelServiceRequestedId(id);
    setOpenCancelModal(true);
  };

  useEffect(() => {
    if (openDetailsPage) {
      navigate(`/vehicle/service-request/${getCompleteRowDetails?.id}`, {
        state: getCompleteRowDetails,
      });
    }
  }, [getCompleteRowDetails, navigate, openDetailsPage]);

  const selectedRowClicked = (service) => {
    setOpenDetailsPage(true);
    setGetCompleteRowDetails(service);
  };

  return (
    <div className="vehicle-info-cont">
      <div
        className="vehicle-info-bottom"
        style={{ boxShadow: `${selectedColor}80 1px 1px 10px 1px` }}
      >
        <div
          className="vehicle-info-bottom-heading"
          style={{ fontSize: "20px" }}
        >
          Service Request
        </div>
        <table className="vehicle-info-bottom-table">
          <thead
            className="thead"
            style={{
              display: "grid",
              padding: "5px 50px",
              gridTemplateColumns: "repeat(7, 1fr)",
            }}
          >
            {header?.map((card, index) => (
              <tr key={index} className="tr" style={{ padding: "5px 0px" }}>
                <td>{card?.label}</td>
              </tr>
            ))}
          </thead>
          <tbody className="table-body">
            {bookingRequestData?.map((serviceRequest, index) => (
              <tr
                key={serviceRequest?.id}
                className="table-body-tr"
                style={{
                  background: index % 2 !== 0 ? "#FFF1EC" : "white",
                  width: "100%",
                  display: "grid",
                  gridTemplateColumns: "repeat(7, 1fr)",
                }}
              >
                <td>{serviceRequest?.id}</td>

                {/* ✅ Service Names as Numeric List */}
                <td>
                  <ol style={{ paddingLeft: "16px", margin: 0 }}>
                    {serviceRequest?.service_details?.map((service, idx) => (
                      <li key={idx}>{service?.name}</li>
                    ))}
                  </ol>
                </td>

                {/* ✅ Sub Services as Numeric List */}
                <td
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    width: "160px",
                  }}
                >
                  <ol style={{ paddingLeft: "16px", margin: 0 }}>
                    {serviceRequest?.service_details?.flatMap((service) =>
                      service?.sub_services?.map((sub, idx) => (
                        <li key={idx}>{sub?.name}</li>
                      ))
                    )}
                  </ol>
                </td>

                {/* ✅ Service Date */}
                <td
                  style={{
                    display: "flex",
                    justifyContent: "start",
                  }}
                >
                  {serviceRequest?.service_date
                    ? formatDate(serviceRequest?.service_date)
                    : ""}
                </td>

                <td
                  style={{
                    display: "flex",
                    justifyContent: "start",
                  }}
                >
                  {serviceRequest?.vehicle_details?.vehicle_number}
                </td>

                <td
                  style={{
                    display: "flex",
                    justifyContent: "start",
                  }}
                >
                  {capitalizeFirstLetter(serviceRequest?.status)}
                </td>

                {/* ✅ Action Column */}
                <td
                  style={{
                    justifyContent: "start",
                    gap: "5px",
                  }}
                >
                  <span
                    style={{
                      background: "#f15a22",
                      borderRadius: "20px",
                      padding: "5px",
                      cursor: "pointer",
                    }}
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Preview"
                    onClick={() => selectedRowClicked(serviceRequest)}
                  >
                    <i
                      className="bi bi-eye-fill"
                      style={{
                        fontSize: "17px",
                        color: "white",
                        padding: "10px",
                      }}
                    ></i>
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modals - left as per original */}
    </div>
  );
};

export default ServiceRequest;
